import React from "react";

import avatar from "../../assets/product-details/avatar-50.png";
import love from "../../assets/product-details/love-blue.png";
import share from "../../assets/product-details/share-blue.png";

export default function BottomProductInfo() {
  return (
    <div className="product-info-bottom">
      <div className="container">
        <div className="avatar">
          <img className="avatar-img" src={avatar} alt="avatar-lite" />
        </div>
        <div className="left">
          <p className="left-shop">Toko Sneaker Maju Mundur</p>
          <div className="left-button">
            <button className="left-button-detail">Lihat Detail Toko</button>
            <button className="left-button-chat">Chat Penjual</button>
          </div>
        </div>
        <div className="price">
          <p className="price-title">Total</p>
          <p className="price-number">Rp.4.250.000</p>
        </div>
        <div className="quantity">
          <div className="quantity-inner">
            <button className="quantity-cremental disabled">-</button>
            <p className="quantity-info">1</p>
            <button className="quantity-cremental">+</button>
          </div>
        </div>
        <div className="right">
          <div className="right-button">
            <button className="right-button-buy">Beli Sekarang</button>
            <button className="right-button-cart">Tambah ke Keranjang</button>
            <button className="right-button-opt">
              <img className="right-button-opt-icon" src={love} alt="" />
            </button>
            <button className="right-button-opt">
              <img className="right-button-opt-icon" src={share} alt="" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
